import { render, staticRenderFns } from "./MainTitle.vue?vue&type=template&id=5536e6ad&scoped=true&"
import script from "./MainTitle.vue?vue&type=script&lang=ts&"
export * from "./MainTitle.vue?vue&type=script&lang=ts&"
import style0 from "./MainTitle.vue?vue&type=style&index=0&id=5536e6ad&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5536e6ad",
  null
  
)

export default component.exports